import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
		path: '/',
		component: () => import('@/views/invite.vue'),
		meta: {
			title: '邀请队员'
		}
	},
	{
		path: '/home',
		component: () => import('@/views/Home.vue'),
		meta: {
			title: '蓝牙测绘官网'
		}
	},
	{
		path: '/upLoad',
		name: 'upLoad',
		component: () => import('@/views/upLoad.vue'),
		meta: {
			title: '下载'
		}
	},

	{
		path: '/agreement',
		component: () => import('@/views/agreement.vue'),
		meta: {
			title: '注册协议'
		}
	},
	{
		  path:'/privacyPolicy',
		  component:()=>import('@/views/privacyPolicy.vue'),
	    meta: {
	      title: '隐私政策'
	    }
	},
	{
		  path:'/protocolAll',
		  component:()=>import('@/views/protocolAll.vue'),
	    meta: {
	      title: '隐私政策和注册协议'
	    }
	},
	{
		path: '/dazzlingAgreement',
		component: () => import('@/views/dazzlingAgreement.vue'),
		meta: {
			title: '注册协议'
		}
	},
	{
		  path:'/dazzlingPrivacyPolicy',
		  component:()=>import('@/views/dazzlingPrivacyPolicy.vue'),
	    meta: {
	      title: '隐私政策'
	    }
	},
	{
		  path:'/dazzlingProtocolAll',
		  component:()=>import('@/views/dazzlingProtocolAll.vue'),
	    meta: {
	      title: '隐私政策和注册协议'
	    }
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	const title = to.meta && to.meta.title;
	if (title) {
		document.title = title;
	}
	next();
});
export default router
